import React, { useState } from "react";
import { useLocation, useNavigate, Navigate } from "react-router-dom";
import BlogEditor from "./BlogEditor";
import { useAuth } from "components/AuthLogin/AuthContext";
import FailModal from "./BlogModal/FailModal";

const BlogModify: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { getCookie } = useAuth();
    const { post } = location.state || {};
    const [isFailModalOpen, setIsFailModalOpen] = useState(false);

    if (!post) {
        return <Navigate to="/blog" replace />;
    }

    const handleSubmit = async (formData: FormData) => {
        const apiToken = getCookie('apiToken');

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/posts/${post.id}`, {
                method: "POST",
                headers: { 'Authorization': `Bearer ${apiToken}` },
                body: formData,
            });

            if (!response.ok) throw new Error("Network response was not ok");

            const responseData = await response.json();
            navigate(`/blog-single/${responseData.contents.id}`);
        } catch (error) {
            console.error("Error:", error);
            setIsFailModalOpen(true);
        }
    };

    return (
        <>
            <BlogEditor initialData={post} onSubmit={handleSubmit} submitButtonText="Update" />
            <FailModal
                isOpen={isFailModalOpen}
                onClose={() => setIsFailModalOpen(false)}
                title="Something went wrong"
                mainMessage="Couldn't update your post."
                subMessage="Please try again."
            />
        </>
    );
};

export default BlogModify;
